import React, { useContext } from "react";
import { ToolbarContext } from "./../../ricos-context";
import { ToolbarButton } from "./../../toolbars-ui";
const RemoveLinkButton = ({ toolbarItem }) => {
  const { t, isMobile } = useContext(ToolbarContext);
  const tooltip = t(toolbarItem.presentation?.tooltip);
  const dataHook = toolbarItem.presentation?.dataHook;
  return /* @__PURE__ */ React.createElement(
    ToolbarButton,
    {
      isMobile,
      tooltip,
      onClick: () => {
        toolbarItem.commands.click();
      },
      Icon: toolbarItem.presentation?.icon,
      dataHook
    }
  );
};
export {
  RemoveLinkButton
};
//# sourceMappingURL=remove-link-button.js.map
